<section class="main-content wrapper content-padding" style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ title }}</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">
        <div class="day-tabs">
          <button
            type="button"
            class="day-tab"
            [class.active]="selectedDay === ''"
            (click)="selectDay('')"
          >
            Tutti
          </button>

          <button
            type="button"
            class="day-tab"
            *ngFor="let day of days"
            [class.active]="selectedDay === day.dayOfWeek"
            (click)="selectDay(day.dayOfWeek)"
          >
            {{ day.label }}
          </button>
        </div>
      </span>
    </div>

    <hr class="gold-hr" />

    <section class="main-content wrapper scroll-delivery">
      <app-pagination
        [limit]="limit"
        [page]="page"
        [count]="count"
        [maxPage]="maxPage"
        (load)="navigate($event)"
      ></app-pagination>

      <div class="custom-data-output has-margin-top" role="table" id="elencoDisponibilita">
        <form
          class="table-row-container row first-row filter"
          [formGroup]="availabilityForm"
          (ngSubmit)="filter()"
          *ngIf="availabilityForm"
        >
          <div class="item data-col-5">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              SR No
            </h4>
            <span class="data">
              
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder(ownerNameSortKey)">
              <i class="sort-icon fas" [ngClass]="orderIcon(ownerNameSortKey)"></i>
              {{ userLabel }}
            </h4>
            <span class="data">
              <input
                type="text"
                [formControlName]="ownerNameFilterKey"
              />
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder(provinceSortKey)">
              <i class="sort-icon fas" [ngClass]="orderIcon(provinceSortKey)"></i>
              Provincia
            </h4>
            <span class="data">
              <input
                type="text"
                [formControlName]="provinceFilterKey"
              />
            </span>
          </div>

          <div class="item center data-col-10">
            <h4 class="title" (click)="navigateOrder('AvailabilityWeekly.available')">Disponibile</h4>
            <span class="data">
              <select formControlName="AvailabilityWeekly.available">
                <option value="">Tutti</option>
                <option value="1">SÌ</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('AvailabilityWeekly.startTime')">
              <i class="sort-icon fas" [ngClass]="orderIcon('AvailabilityWeekly.startTime')"></i>
              Disponibilità
            </h4>
            <span class="data">
              <div class="date">Da:</div>
              <input
                class="date"
                type="time"
                formControlName="AvailabilityWeekly.startTime"
              />
            </span>
            <span class="data">
              <div class="date">A:</div>
              <input
                class="date"
                type="time"
                formControlName="AvailabilityWeekly.endTime"
              />
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title" >
              <i class="sort-icon fas" ></i>
              Date Speciali
            </h4>
            <span class="data">
              
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">Azioni</h4>
            <span class="data-row-left btn-container">
              <button
                type="submit"
                class="btn vertical align-items-center"
              >
                Ricerca <i class="fas fa-search"></i>
              </button>

              <br />

              <button
                type="button"
                class="btn vertical align-items-center"
                (click)="resetFilters()"
              >
                Reset <i class="fas fa-times-circle"></i>
              </button>
            </span>
          </div>
        </form>

        <div
          class="table-row-container row"
          *ngFor="let availability of availabilities; let i = index"
        >
          <div class="item data-col-5">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              SR No
            </h4>
            <div class="data data-id">
              <div>
                <a [routerLink]="getAvailabilityLink(availability)">
                  #{{ getSerialNumber(i) }}
                </a>
              </div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              {{ userLabel }}
            </h4>
            <div class="data">
              <div>
                <a [routerLink]="getAvailabilityLink(availability)">
                  {{ getOwnerName(availability) }}
                </a>
              </div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Provincia
            </h4>

            <div class="data">
              <div *ngIf="getOwnerProvinces(availability).length > 0">
                <span
                  *ngFor="let item of getOwnerProvinces(availability); let last = last"
                >
                  <a [routerLink]="getAvailabilityLink(availability)">
                    <b>{{ getProvinceCode(item) }}</b>
                  </a>
                  <ng-container *ngIf="!last">, </ng-container>
                </span>
              </div>

              <div *ngIf="getOwnerProvinces(availability).length === 0">
                N/A
              </div>
            </div>
          </div>

          <div class="item center data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Disponibile
            </h4>

            <div class="data">
              <a [routerLink]="getAvailabilityLink(availability)">
                {{ isSelectedDayAvailable(availability) ? 'SÌ' : 'No' }}
              </a>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Disponibilità
            </h4>

            <div class="data">
              <ng-container *ngIf="getSelectedWeeklySlots(availability).length > 0; else noSlots">
                <div
                  *ngFor="let slot of getSelectedWeeklySlots(availability)"
                >
                  <a [routerLink]="getAvailabilityLink(availability)">
                    {{ formatTimeShow(slot.start, slot.end) }}
                  </a>
                </div>
              </ng-container>

              <ng-template #noSlots>
                N/A
              </ng-template>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Date Speciali
            </h4>

            <div class="data">
              <ng-container *ngIf="availability?.overrides?.length > 0; else noOverrides">
                <a [routerLink]="getAvailabilityLink(availability)">
                    {{ availability.overrides.length }} eccezione/i
                </a>
              </ng-container>

              <ng-template #noOverrides>
                N/A
              </ng-template>
            </div>
          </div>

          <div class="item data-col-5">
            <h4 class="title">Azioni</h4>

            <span class="data">
              <button
                type="button"
                class="btn hvr-grow"
                [routerLink]="getAvailabilityLink(availability)"
              >
                Vedi
              </button>
            </span>
          </div>
        </div>

        <div class="table-row-container row" *ngIf="!availabilities?.length">
          <div class="item data-col-100">
            <div class="data">
              Nessuna disponibilità trovata.
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>